
import HomePage from '../pages/home.f7.html';
import AboutPage from '../pages/about.f7.html';
import FormPage from '../pages/form.f7.html';
import CatalogPage from '../pages/catalog.f7.html';
import ProductPage from '../pages/product.f7.html';
import SettingsPage from '../pages/settings.f7.html';
import bet4d from '../pages/bet4d.f7.html';
import bet4dSG from '../pages/bet4dSG.f7.html';
import bet4dOnly from '../pages/bet4dOnly.f7.html';
import bet4dSGOnly from '../pages/bet4dSGOnly.f7.html';
import bet6d from '../pages/bet6d.f7.html';
import betlist from '../pages/betlist.f7.html';
import report from '../pages/report.f7.html';
import receipt from '../pages/receipt.f7.html';
import jackpot from '../pages/jackpot.f7.html';
import result from '../pages/result.f7.html';
import profile from '../pages/profile.f7.html';

import CASHIER_home from '../pages/CASHIER_home.f7.html';
import CASHIER_receipt from '../pages/CASHIER_receipt.f7.html';
import CASHIER_pay from '../pages/CASHIER_pay.f7.html';
import CASHIER_report from '../pages/CASHIER_report.f7.html';

import KIOSK_home from '../pages/KIOSK_home.f7.html';
import KIOSK_6d_GD from '../pages/KIOSK_6d_GD.f7.html';
import KIOSK_4d_GD from '../pages/KIOSK_4d_GD.f7.html';
import KIOSK_4d_GD_Only from '../pages/KIOSK_4d_GD_Only.f7.html';
import KIOSK_4d_SG from '../pages/KIOSK_4d_SG.f7.html';
import KIOSK_4d_SG_S from '../pages/KIOSK_4d_SG_S.f7.html';
import KIOSK_4d_SG_Only from '../pages/KIOSK_4d_SG_Only.f7.html';
import KIOSK_receipt from '../pages/KIOSK_receipt.f7.html';
import KIOSK_receipt_winning from '../pages/KIOSK_receipt_winning.f7.html';
import KIOSK_result_GD from '../pages/KIOSK_result_GD.f7.html';
import KIOSK_result_SG from '../pages/KIOSK_result_SG.f7.html';
import KIOSK_result_ST from '../pages/KIOSK_result_ST.f7.html';
import KIOSK_winning from '../pages/KIOSK_winning.f7.html';
import KIOSK_rebuy from '../pages/KIOSK_rebuy.f7.html';
import KIOSK_jackpot from '../pages/KIOSK_jackpot.f7.html';
import KIOSK_4d_ST from '../pages/KIOSK_4d_ST.f7.html';
import KIOSK_6d_ST from '../pages/KIOSK_6d_ST.f7.html';
import KIOSK_test from '../pages/KIOSK_test.f7.html';
import settings_test from '../pages/settings_test.f7.html';
import KIOSK_PICK_GD from '../pages/KIOSK_PICK_GD.f7.html';
import KIOSK_PICK_SG from '../pages/KIOSK_PICK_SG.f7.html';
import KIOSK_PICK_SG_S from '../pages/KIOSK_PICK_SG_S.f7.html';
import KIOSK_PICK_ST from '../pages/KIOSK_PICK_ST.f7.html';

import WEB_home from '../pages/WEB_home.f7.html';
import WEB_QR from '../pages/WEB_QR.f7.html';
import WEB_history from '../pages/WEB_history.f7.html';

import CHECK_home from '../pages/CHECK_home.f7.html';

import AGENT_home from '../pages/AGENT_home.f7.html';
import AGENT_jackpot from '../pages/AGENT_jackpot.f7.html';
import AGENT_winning from '../pages/AGENT_winning.f7.html';
import AGENT_betlist from '../pages/AGENT_betlist.f7.html';
import AGENT_report from '../pages/AGENT_report.f7.html';
import AGENT_pay from '../pages/AGENT_pay.f7.html';
import AGENT_wallet from '../pages/AGENT_wallet.f7.html';

import GEN_receipt from '../pages/GEN_receipt.f7.html';
import GEN_buypaper from '../pages/GEN_buypaper.f7.html';
import GEN_buytopup from '../pages/GEN_buytopup.f7.html';
import GEN_payoutstanding from '../pages/GEN_payoutstanding.f7.html';
import GEN_longlong from '../pages/GEN_longlong.f7.html';
import GEN_history from '../pages/GEN_history.f7.html';
import GEN_withdraw from '../pages/GEN_withdraw.f7.html';

import DynamicRoutePage from '../pages/dynamic-route.f7.html';
import RequestAndLoad from '../pages/request-and-load.f7.html';
import NotFoundPage from '../pages/404.f7.html';

var routes = [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/about/',
    component: AboutPage,
  },
  {
    path: '/form/',
    component: FormPage,
  },
  {
    path: '/catalog/',
    component: CatalogPage,
  },
  {
    path: '/product/:id/',
    component: ProductPage,
  },
  {
    path: '/settings/',
    component: SettingsPage,
  },
  {
    path: '/bet4d/',
    component: bet4d,
  },
  {
    path: '/bet4dOnly/',
    component: bet4dOnly,
  },
  {
    path: '/bet6d/',
    component: bet6d,
  },
  {
    path: '/betlist/',
    component: betlist,
  },
  {
    path: '/report/',
    component: report,
  },
  {
    path: '/bet4dSG/',
    component: bet4dSG,
  },
  {
    path: '/bet4dSGOnly/',
    component: bet4dSGOnly,
  },
  {
    path: '/receipt/',
    component: receipt,
  },
  {
    path: '/jackpot/',
    component: jackpot,
  },
  {
    path: '/result/',
    component: result,
  },
  {
    path: '/profile/',
    component: profile,
  },
  {
    path: '/cashier_home/',
    component: CASHIER_home,
  },
  {
    path: '/cashier_receipt/',
    component: CASHIER_receipt,
  },
  {
    path: '/cashier_pay/',
    component: CASHIER_pay,
  },
  {
    path: '/cashier_report/',
    component: CASHIER_report,
  },

  //KIOSK ROUTE BEGIN
  {
    path: '/kiosk_home/',
    component: KIOSK_home,
  },
  {
    path: '/kiosk_6d_GD/',
    component: KIOSK_6d_GD,
  },
  {
    path: '/kiosk_pick_GD/',
    component: KIOSK_PICK_GD,
  },
  {
    path: '/kiosk_pick_SG/',
    component: KIOSK_PICK_SG,
  },
  {
    path: '/kiosk_pick_SG_S/',
    component: KIOSK_PICK_SG_S,
  },
  {
    path: '/kiosk_pick_ST/',
    component: KIOSK_PICK_ST,
  },
  {
    path: '/kiosk_4d_GD/',
    component: KIOSK_4d_GD,
  },
  {
    path: '/kiosk_4d_GD_Only/',
    component: KIOSK_4d_GD_Only,
  },
  {
    path: '/kiosk_4d_SG/',
    component: KIOSK_4d_SG,
  },
  {
    path: '/kiosk_4d_SG_S/',
    component: KIOSK_4d_SG_S,
  },
  {
    path: '/kiosk_4d_SG_Only/',
    component: KIOSK_4d_SG_Only,
  },
  {
    path: '/kiosk_4d_ST/',
    component: KIOSK_4d_ST,
  },
  {
    path: '/kiosk_6d_ST/',
    component: KIOSK_6d_ST,
  },
  {
    path: '/kiosk_receipt/',
    component: KIOSK_receipt,
  },
  {
    path: '/kiosk_result_gd/',
    component: KIOSK_result_GD,
  },
  {
    path: '/kiosk_result_sg/',
    component: KIOSK_result_SG,
  },
  {
    path: '/kiosk_result_st/',
    component: KIOSK_result_ST,
  },
  {
    path: '/kiosk_winning/',
    component: KIOSK_winning,
  },
  {
    path: '/kiosk_receipt_winning/',
    component: KIOSK_receipt_winning,
  },
  {
    path: '/kiosk_rebuy/',
    component: KIOSK_rebuy,
  },
  {
    path: '/kiosk_jackpot/',
    component: KIOSK_jackpot,
  },
  {
    path: '/kiosk_test/',
    component: KIOSK_test,
  },
  {
    path: '/settings_test/',
    component: settings_test,
  },
  {
    path: '/web_home/',
    component: WEB_home,
  },
  {
    path: '/web_qr/',
    component: WEB_QR,
  },
  {
    path: '/web_history/',
    component: WEB_history,
  },
  {
    path: '/check_home/',
    component: CHECK_home,
  },
  {
    path: '/agent_home/',
    component: AGENT_home,
  },
  {
    path: '/agent_jackpot/',
    component: AGENT_jackpot,
  },
  {
    path: '/agent_winning/',
    component: AGENT_winning,
  },
  {
    path: '/agent_betlist/',
    component: AGENT_betlist,
  },
  {
    path: '/agent_report/',
    component: AGENT_report,
  },
  {
    path: '/agent_pay/',
    component: AGENT_pay,
  },
  {
    path: '/agent_wallet/',
    component: AGENT_wallet,
  },
  {
    path: '/gen_receipt/',
    component: GEN_receipt,
  },
  {
    path: '/gen_buypaper/',
    component: GEN_buypaper,
  },
  {
    path: '/gen_buytopup/',
    component: GEN_buytopup,
  },
  {
    path: '/gen_payoutstanding/',
    component: GEN_payoutstanding,
  },
  {
    path: '/gen_longlong/',
    component: GEN_longlong,
  },
  {
    path: '/gen_history/',
    component: GEN_history,
  },
  {
    path: '/gen_withdraw/',
    component: GEN_withdraw,
  },
  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function ({ router, to, resolve }) {
      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = to.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            props: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;